// extracted by mini-css-extract-plugin
module.exports = {"desc":"index_desc__e8vxs","boxSelect":"index_boxSelect__GhhW1","selected":"index_selected__4Mth7","button":"index_button__YSGIq"};